import { jsx as a, jsxs as d } from "react/jsx-runtime";
import m from "classnames";
const t = ({
  showHandleBar: e,
  children: r,
  className: s,
  ...c
}) => /* @__PURE__ */ a(
  "div",
  {
    className: m("modal_header", s, {
      header_type2: e
    }),
    ...c,
    children: /* @__PURE__ */ d("div", { className: "inner_g", children: [
      e && /* @__PURE__ */ a("span", { className: "btn_control" }),
      r
    ] })
  }
);
export {
  t as default
};
